const MessageType = {
  Human: 'human',
  AI: 'ai',
  AI_Intro: 'ai_intro',
  Typing: 'typing',
};

export default MessageType;
